import React, { useState, useEffect, useCallback } from 'react'
import classes from './Profile.scss'

import { useDispatch, useSelector } from 'react-redux'
import { fetchRoleOptions, updateProfile } from '../../../store/actions'
import {
  updateObject,
  checkValidity,
  updateFormOptions,
  getMultiSelectvalue
} from '../../../helpers/utils'
import Card from '../../../components/UI/Card/Card'
import CardHeader from '../../../components/UI/Card/Header/Header'
import CardContent from '@material-ui/core/CardContent'
import Button from '../../../components/UI/Button/Button'
import Image from '../../../components/Image/Image'
import Alert from '../../../components/Alert/Alert'
import InputGroup from '../../../components/UI/Forms/InputGroup/InputGroup'
import { withTranslate } from 'react-redux-multilingual'
import { Grid } from '@material-ui/core'
import { useHistory } from 'react-router-dom'

function Profile({ translate }, props) {
  const dispatch = useDispatch()

  const [filters, setFilters] = useState({
    user_name: {
      classes: 'UserName',
      label: translate('username'),
      elementType: 'input',
      elementConfig: {
        autoComplete: 'user_name',
        name: 'user_name'
      },
      value: '',
      validation: {
        required: true
      },
      valid: false,
      touched: false,
      error: null
    },
    first_name: {
      classes: 'FirstName',
      label: translate('firstName'),
      elementType: 'input',
      elementConfig: {
        type: 'text'
      },
      value: '',
      validation: {
        required: true
      },
      valid: false,
      touched: false,
      error: null
    },
    last_name: {
      classes: 'LastName',
      label: translate('lastName'),
      elementType: 'input',
      elementConfig: {
        type: 'text'
      },
      value: '',

      validation: {
        required: true
      },
      valid: false,
      touched: false,
      error: null
    },
    email: {
      classes: 'Email',
      label: translate('eMail'),
      elementType: 'input',
      elementConfig: {
        type: 'text'
      },
      value: '',
      validation: {
        required: true,
        isEmail: true
      },
      valid: false,
      touched: false,
      error: null
    },
    roles: {
      classes: 'Role',
      label: translate('role'),
      elementType: 'newmultiSelect',
      elementConfig: {
        type: 'text',
        options: [{ value: '0', label: 'Select Role' }]
      },
      value: [],
      validation: false,
      valid: true,
      touched: false,
      error: null
    },
    password: {
      classes: 'Password',
      label: translate('password'),
      elementType: 'input',
      elementConfig: {
        type: 'password',
        autoComplete: 'new-password'
      },
      value: '',
      validation: {
        required: true
      },
      valid: false,
      touched: false,
      error: null
    },
    confirm_password: {
      classes: 'Password',
      label: translate('confirmPassword'),
      elementType: 'input',
      elementConfig: {
        type: 'password'
      },
      validation: {
        required: true
      },
      hidden: true
    },
    is_ldap: {
      classes: 'LDAP',
      label: translate('ldap'),
      elementType: 'checkbox',
      elementConfig: {
        disabled: true
      },
      value: true,
      validation: false,
      valid: true
    },
    is_active: {
      classes: 'Active',
      label: 'Active',
      elementType: 'checkbox',
      value: true,
      validation: false,
      valid: true
    }
  })

  // Redux Props
  const userInfo = useSelector(state => state.auth.user)
  const roleOptions = useSelector(state => state.user.roleOption)

  useEffect(() => {
    dispatch(fetchRoleOptions())
  }, [dispatch])

  const handleChangeFilters = useCallback(modelParam => {
    if (modelParam.password.value !== '' && modelParam.confirm_password.hidden) {
      setFilters(prevControls => {
        const targetLevelItem = prevControls.confirm_password
        let data = updateObject(prevControls, {
          confirm_password: {
            ...targetLevelItem,
            hidden: false
          }
        })
        return data
      })
    }
  }, [])

  useEffect(() => {
    setFilters(prevControls => {
      const targetLevelItem = prevControls.roles
      let data = updateObject(prevControls, {
        roles: updateFormOptions(
          roleOptions,
          targetLevelItem,
          'role_id',
          'role_id',
          'role_name',
          'Select Role'
        )
      })
      return data
    })
  }, [roleOptions])

  useEffect(() => {
    setFilters(prevControls => {
      const updatedControls = Object.entries(prevControls).reduce((updated, filterItem) => {
        const [filterKey, filterAttr] = filterItem
        const x = userInfo[filterKey]
        let elementConfig = { ...filterAttr.elementConfig }

        const updatedAttr = { ...filterAttr, value: x }

        if (userInfo.is_ldap) {
          elementConfig = { ...filterAttr.elementConfig, disabled: true }
        } else {
          if (filterKey === 'password' || filterKey === 'confirm_password') {
            elementConfig = { ...filterAttr.elementConfig }
          } else {
            elementConfig = { ...filterAttr.elementConfig, disabled: true }
          }
        }
        let value = ''
        if (filterKey === 'roles') {
          filterAttr.elementConfig.options = roleOptions.map(item => {
            return {
              value: item.role_id,
              label: item.role_name
            }
          })
        }
        if (filterAttr.elementType === 'newmultiSelect') {
          value = getMultiSelectvalue(
            userInfo[filterKey].map(item => item.role_id),
            filterAttr.elementConfig.options,
            'role_id'
          )
        } else if (filterAttr.elementType === 'checkbox') {
          value = !!userInfo[filterKey]
        } else if (userInfo[filterKey]) {
          value = userInfo[filterKey]
        } else {
          value = ''
        }

        return updateObject(updated, { [filterKey]: { ...updatedAttr, value, elementConfig } })
      }, {})

      return updatedControls
    })
  }, [userInfo, roleOptions])

  const updateProfileHandler = e => {
    e.preventDefault()

    let data = Object.entries(filters).reduce((data, entry) => {
      let [key, attr] = entry
      let value = ''
      if (attr.elementType === 'newmultiSelect') {
        value = attr.value.map(res => {
          return res.value
        })
      } else {
        value = attr.value
      }
      if (key === 'user_name') {
        return updateObject(data, { [key]: value, emp_code: value })
      } else if (key === 'confirm_password') {
        return { ...data }
      } else {
        return updateObject(data, { [key]: value })
      }
    }, {})

    dispatch(updateProfile(userInfo.user_id, { ...data }))
  }

  const inputChangeHandler = (key, event) => {
    const inputGroup = filters
    const userItem = inputGroup[key]
    let inputValue = ''

    switch (userItem.elementType) {
      case 'newmultiSelect':
        inputValue = event
        break
      case 'checkbox':
        inputValue = !userItem.value
        break
      default:
        inputValue = event.target.value
        break
    }
    const { isValid, error } = checkValidity(inputValue, userItem.validation, userItem.label)

    const updatedUserItem = {
      ...userItem,
      value: inputValue,
      valid: isValid,
      error: error,
      touched: true
    }

    const updateGroup = updateObject(inputGroup, { [key]: updatedUserItem })
    let formIsValid = true
    Object.values(updateGroup).map(attr => {
      return (formIsValid = formIsValid && attr.valid)
    })
    if (key === 'password') {
      let data = updateObject(filters, {
        [key]: updatedUserItem,
        confirm_password: {
          ...filters.confirm_password,
          label: translate('confirmPassword'),
          validation: {
            required: true,
            shouldEqualTo: { value: inputValue, fieldName: 'Password' }
          }
        }
      })
      setFilters(data)
      handleChangeFilters(data)
    } else {
      setFilters(updateObject(filters, { [key]: updatedUserItem }))
    }
  }
  let history = useHistory()

  const cancelClick = () => {
    history.push('/')
  }

  return (
    <>
      <Alert />
      <Card>
        <CardHeader>
          <Grid item xs={1}>
            {translate('profile')}
          </Grid>
        </CardHeader>
        <CardContent className={classes.Controls}>
          <div className={classes.Containimg}>
            <Image
              src={userInfo?.employee?.image_path}
              variant={'circle'}
              alt={userInfo.emp_id}
              className={classes.Image}
            />
          </div>
          <Grid
            container
            justify='center'
            alignItems='center'
            item
            xs={11}
            sm={12}
            md={9}
            spacing={1}
            className={classes.Content}>
            <Input filters={filters} inputChangeHandler={inputChangeHandler} />
          </Grid>
          <Grid container direction='row' justify='flex-end' alignItems='center' spacing={2}>
            <Grid item xs={4} sm={2}>
              <Button
                color={'primary'}
                clicked={updateProfileHandler}
                disabled={!filters.confirm_password?.valid || !!userInfo.is_ldap}>
                {translate('save')}
              </Button>
            </Grid>
            <Grid item xs={4} sm={2}>
              <Button clicked={cancelClick}>{translate('cancel')}</Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </>
  )
}

export default withTranslate(Profile)

const Input = props => {
  let data = props.filters
  let input = Object.entries(data).map(item => {
    let [key, attr] = item

    let input = (
      <InputGroup
        key={key}
        label={attr.label}
        inputType={attr.elementType}
        configs={attr.elementConfig}
        invalid={!attr.valid}
        variant={'outlined'}
        validations={attr.validation}
        touched={attr.touched}
        changed={e => props.inputChangeHandler(key, e)}
        inputValue={attr.value}
        validationError={attr.error}
        hidden={attr.hidden}
      />
    )
    if (key === 'password' && props.filters.is_ldap.value) {
      input = null
    }
    return (
      <Grid item xs={12} sm={12} md={4} key={key}>
        <CardContent className={classes.TextField}>{input}</CardContent>
      </Grid>
    )
  })
  return input
}
